import { userLanguage } from "commonAssets/js/constants";

export function removeClaimFile(e, claim) {
    // The 'this' context refers to the .remove span element that was clicked
    const row = this.parentElement; // Get the parent <li> element
    const parent = row.parentElement; // Get the file list container
    let added = parent.querySelectorAll("li:not([disabled])");
    const index = [].indexOf.call(added, row);

    // Handle case where claim is not provided (fallback to global if available)
    if (!claim && typeof window !== "undefined" && window.claim) {
        claim = window.claim;
    }

    // Validate that we have the necessary data
    if (!claim || !claim.uploads) {
        console.error("removeClaimFile: claim or claim.uploads is missing");
        return;
    }

    if (index === -1) {
        console.error("removeClaimFile: Could not find row in parent element");
        return;
    }

    if (!claim.uploads[index]) {
        console.error("removeClaimFile: No upload found at index", index);
        return;
    }

    // Multi-language confirmation message
    const messages = {
        en: "Are you sure you want to remove this file?",
        es: "¿Estás seguro de que quieres eliminar este archivo?",
        fr: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
    };

    const message = messages[userLanguage] || messages.en;
    const fileName = claim.uploads[index].file
        ? claim.uploads[index].file.name
        : "Unknown file";
    const description = claim.uploads[index].description || "No description";
    const confirmText = `${message}\nFile Name: ${fileName}\nDescription: ${description}`;

    if (window.confirm(confirmText)) {
        parent.removeChild(row);
        claim.uploads.splice(index, 1);
    }

    // Recalculate after potential removal
    added = parent.querySelectorAll("li:not([disabled])");
    document
        .getElementById("file-list")
        .classList[added.length === 1 ? "add" : "remove"]("d-none");
    document
        .getElementById("no-files")
        .classList[added.length === 1 ? "remove" : "add"]("d-none");
}
